import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Plus, Trash2, Edit2, X } from "lucide-react";
import { toast } from "sonner";

const EMPTY = {
    title: "", slug: "", excerpt: "", body: "",
    image_url: "", category: "Company News", author: "Peppa Target", is_published: true,
};

export default function AdminNews() {
    const [items, setItems] = useState([]);
    const [editing, setEditing] = useState(null);

    function load() { api.get("/news").then((r) => setItems(r.data)); }
    useEffect(load, []);

    async function save(payload) {
        try {
            if (payload.id) {
                await api.put(`/news/${payload.id}`, payload);
                toast.success("Article updated");
            } else {
                await api.post("/news", payload);
                toast.success("Article published");
            }
            setEditing(null);
            load();
        } catch (err) {
            toast.error("Save failed");
        }
    }

    async function remove(id) {
        if (!confirm("Delete this article?")) return;
        await api.delete(`/news/${id}`);
        toast.success("Deleted");
        load();
    }

    return (
        <div className="p-8" data-testid="admin-news">
            <div className="flex items-center justify-between mb-8">
                <h1 className="font-display text-3xl font-bold">News & articles</h1>
                <button onClick={() => setEditing({ ...EMPTY })} className="inline-flex items-center gap-2 bg-primary text-white px-4 py-2 font-semibold">
                    <Plus className="w-4 h-4" /> New article
                </button>
            </div>
            <div className="bg-white border border-border overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-muted text-left">
                        <tr>
                            <th className="px-4 py-3">Title</th>
                            <th className="px-4 py-3">Category</th>
                            <th className="px-4 py-3">Date</th>
                            <th className="px-4 py-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((n) => (
                            <tr key={n.id} className="border-t border-border">
                                <td className="px-4 py-3 font-semibold">{n.title}</td>
                                <td className="px-4 py-3">{n.category}</td>
                                <td className="px-4 py-3 text-xs">{new Date(n.created_at).toLocaleDateString()}</td>
                                <td className="px-4 py-3 text-right">
                                    <button onClick={() => setEditing(n)} className="p-2 hover:text-primary"><Edit2 className="w-4 h-4" /></button>
                                    <button onClick={() => remove(n.id)} className="p-2 hover:text-primary"><Trash2 className="w-4 h-4" /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {editing && <NewsForm initial={editing} onClose={() => setEditing(null)} onSave={save} />}
        </div>
    );
}

function NewsForm({ initial, onClose, onSave }) {
    const [form, setForm] = useState(initial);
    const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
    return (
        <div className="fixed inset-0 bg-ink/70 z-50 flex items-center justify-center p-4" onClick={onClose}>
            <form onSubmit={(e) => { e.preventDefault(); onSave(form); }} className="bg-white max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-4">
                    <h3 className="font-display text-2xl font-bold">{form.id ? "Edit" : "New"} article</h3>
                    <button type="button" onClick={onClose}><X /></button>
                </div>
                <div className="grid gap-3">
                    <input required value={form.title} onChange={(e) => set("title", e.target.value)} placeholder="Title" className="border border-border px-3 py-2" />
                    <input required value={form.slug} onChange={(e) => set("slug", e.target.value)} placeholder="slug" className="border border-border px-3 py-2" />
                    <input value={form.image_url} onChange={(e) => set("image_url", e.target.value)} placeholder="Image URL" className="border border-border px-3 py-2" />
                    <select value={form.category} onChange={(e) => set("category", e.target.value)} className="border border-border px-3 py-2">
                        {["Company News", "Product Launches", "Press Releases", "Events", "Announcements"].map((c) => <option key={c}>{c}</option>)}
                    </select>
                    <input value={form.author} onChange={(e) => set("author", e.target.value)} placeholder="Author" className="border border-border px-3 py-2" />
                    <textarea required value={form.excerpt} onChange={(e) => set("excerpt", e.target.value)} placeholder="Excerpt" rows={2} className="border border-border px-3 py-2" />
                    <textarea required value={form.body} onChange={(e) => set("body", e.target.value)} placeholder="Full body" rows={8} className="border border-border px-3 py-2" />
                </div>
                <button type="submit" className="mt-4 w-full bg-primary text-white py-2.5 font-semibold hover:bg-primary-hover">Save</button>
            </form>
        </div>
    );
}
